/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_Li2Inputs */

const en_guide_large_json_files_s6_li2 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files <strong>5-50 MB</strong>: Formatting and minification work well; tree view may be slow`)
};

const ko_guide_large_json_files_s6_li2 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>5-50 MB</strong> 파일: 포맷팅과 압축은 잘 작동; 트리 뷰는 느릴 수 있음`)
};

const ja_guide_large_json_files_s6_li2 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>5〜50MB</strong>のファイル: フォーマットと圧縮は問題なく動作、ツリービューは遅くなる場合あり`)
};

/**
* | output |
* | --- |
* | "Files <strong>5-50 MB</strong>: Formatting and minification work well; tree view may be slow" |
*
* @param {Guide_Large_Json_Files_S6_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_li2 = /** @type {((inputs?: Guide_Large_Json_Files_S6_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_li2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_li2(inputs)
	return ja_guide_large_json_files_s6_li2(inputs)
});